import React from 'react';
import PropTypes from 'prop-types';
import ErrorText from 'components/snippets/errorText';
import uniqueID from 'helpers/uniqueID';
import Lang from 'libraries/Lang';

const HotelOccupancyHOC = (InterfaceComponent) => {
    const HotelOccupancy = (props) => {
        const {
            visible,
            occupancy,
            errors,
            onVisibilityChange,
            onChange,
            hotelType,
            fromFH,
        } = props;
        const addRoom = (event) => {
            const rooms = parseInt(event.target.value, 10);

            let updateOccupancy = [...occupancy];
            if (rooms > occupancy.length) {
                for (let i = updateOccupancy.length; i < rooms; i++) {
                    updateOccupancy.push({ adults: 2, children: 0, ages: [] });
                }
            } else {
                updateOccupancy = updateOccupancy.slice(0, rooms);
            }

            onChange(updateOccupancy, `${rooms}-rooms`);
        };

        const changeAdults = (event, element) => {
            const adults = event.target.value;
            const parts = element.split('-');
            const room = Object.assign({}, occupancy[parts[0]]);

            room.adults = parseInt(adults, 10);

            const newOccupancy = [...occupancy.slice(0, [parts[0]]), room, ...occupancy.slice(parseInt(parts[0], 10) + 1)];

            onChange(newOccupancy, element);
        };

        const changeChild = (event, element) => {
            const children = parseInt(event.target.value, 10);
            const parts = element.split('-');
            let ages = Object.assign([], occupancy[parts[0]].ages);

            if (ages.length < children) {
                for (let i = ages.length; i < children; i++) {
                    ages.push('');
                }
            } else {
                ages = ages.slice(0, children);
            }
            const room = { adults: occupancy[parts[0]].adults, children, ages };
            const newOccupancy = [...occupancy.slice(0, [parts[0]]), room, ...occupancy.slice(parseInt(parts[0], 10) + 1)];

            onChange(newOccupancy, element);
        };

        const changeChildAge = (event, element) => {
            const age = event.target.value;
            const parts = element.split('-');
            const room = Object.assign({}, occupancy[parts[0]]);

            room.ages[parts[2]] = age;

            const newOccupancy = [...occupancy.slice(0, [parts[0]]), room, ...occupancy.slice(parseInt(parts[0], 10) + 1)];
            onChange(newOccupancy, element);
        };

        const clickGuest = () => {
            onVisibilityChange(!visible);
        };

        const handleTabKey = (e) => {
            if(e.key == 'Tab') {
                onVisibilityChange(!visible);
            }
        }

        const id = uniqueID();

        let guests = 0;

        occupancy.forEach((room) => {
            guests += room.adults + room.children;
        });

        return (
            <div className="htl_popover">
                <InterfaceComponent showGuests={clickGuest} tabKeyPress={handleTabKey} guests={guests} rooms={occupancy.length} />
                <div className={`popover guests-popover ${visible ? '' : 'hidden'}`}>
                    {/* <button type="button" className="popover-close" onClick={clickGuest} aria-label="Close occupancy" /> */}
                    <div className="custom-form-element">
                        <div className="">
                            <div className="room-title">{hotelType != 'M' ? `${Lang.trans('engine.select')} ${Lang.trans('engine.rooms')}` : 'Adults and Children'}</div>
                            {
                                (hotelType != 'M')
                                    ? (
                                        <div className="row gutter-10">
                                            <div className="col-12 select-container">
                                                <label htmlFor={`dyn_rooms_${id}`}>{Lang.trans('engine.rooms')}</label>
                                                <div className="element-container input-chevron-down">
                                                    <select id={`dyn_rooms_${id}`} className="select-custom" value={occupancy.length} onChange={addRoom}>
                                                        <option value="1">1</option>
                                                        <option value="2">2</option>
                                                        {fromFH !== true ? (
                                                            <>
                                                                <option value="3">3</option>
                                                                <option value="4">4</option>
                                                                <option value="5">5</option>
                                                                <option value="6">6</option>
                                                            </>
                                                        )
                                                            : null}
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                    : null
                            }

                            {occupancy.map((room, index) => (
                                <div key={index}>
                                    {hotelType != 'M'
                                        ? <div className="room-title">{Lang.trans('engine.room')} {index + 1}</div>
                                        : null}
                                    {errors[`occupancy-${index}`] && (
                                        <div className="error-container w-100 mb-2">
                                            {Object.keys(errors[`occupancy-${index}`]).map((ageIndex) => (
                                                <ErrorText error={{ message: errors[`occupancy-${index}`][ageIndex], id: `${index}-${ageIndex}` }} />
                                            ))}
                                        </div>
                                    )}
                                    <div className="row gutter-10">
                                        <div className="col-6 select-container">
                                            <label htmlFor={`dyn_adults${index}_${id}`}>{Lang.trans('engine.adults')}</label>
                                            <div className="element-container input-chevron-down">
                                                <select id={`dyn_adults${index}_${id}`} className="select-custom" value={room.adults} onChange={(event) => changeAdults(event, `${index}-adults`)}>
                                                    <option value="1">1</option>
                                                    <option value="2">2</option>
                                                    <option value="3">3</option>
                                                    <option value="4">4</option>
                                                    <option value="5">5</option>
                                                    <option value="6">6</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-6 select-container">
                                            <label htmlFor={`dyn_children${index}_${id}`}>{Lang.trans('engine.children')}</label>
                                            <div className="element-container input-chevron-down">
                                                <select id={`dyn_children${index}_${id}`} className="select-custom" value={room.children} onChange={(event) => changeChild(event, `${index}-children`)} onKeyDown={((room.ages.length == 0) && ((occupancy.length - 1) == index)) ? handleTabKey : null}>
                                                    <option value="0">0</option>
                                                    <option value="1">1</option>
                                                    <option value="2">2</option>
                                                    <option value="3">3</option>
                                                    <option value="4">4</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    {room.ages.length > 0 && (
                                        <div className="child-age">
                                            <span>{Lang.trans('engine.child_age_upon_return')}</span>
                                            <div className="row gutter-10">
                                                {room.ages.map((age, i) => (
                                                    <div key={i} className="col-6 select-container">
                                                        <label className="label-secondary" htmlFor={`dyn_child-${index}-${i}_${id}`}>{Lang.trans('engine.child')} {i + 1}</label>
                                                        <div className="element-container input-chevron-down">
                                                            <select id={`dyn_child-${index}-${i}_${id}`} className="select-custom" value={age} onChange={(event) => changeChildAge(event, `${index}-childAge-${i}`)} onKeyDown={((room.ages.length - 1) == i) && ((occupancy.length - 1) == index) ? handleTabKey : null}>
                                                                <option value="">--</option>
                                                                <option value="IN">INF</option>
                                                                <option value="2">2</option>
                                                                <option value="3">3</option>
                                                                <option value="4">4</option>
                                                                <option value="5">5</option>
                                                                <option value="6">6</option>
                                                                <option value="7">7</option>
                                                                <option value="8">8</option>
                                                                <option value="9">9</option>
                                                                <option value="10">10</option>
                                                                <option value="11">11</option>
                                                                <option value="12">12</option>
                                                                <option value="13">13</option>
                                                                <option value="14">14</option>
                                                                <option value="15">15</option>
                                                                <option value="16">16</option>
                                                                <option value="17">17</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    HotelOccupancy.propTypes = {
        occupancy: PropTypes.instanceOf(Array).isRequired,
        onChange: PropTypes.func.isRequired,
        errors: PropTypes.instanceOf(Object).isRequired,
        visible: PropTypes.bool.isRequired,
        onVisibilityChange: PropTypes.func.isRequired,
        fromFH: PropTypes.func.isRequired,
    };

    return HotelOccupancy;
};

export default HotelOccupancyHOC;
